import { render, staticRenderFns } from "./CategoryStep.vue?vue&type=template&id=5132f3d9&scoped=true"
import script from "./CategoryStep.vue?vue&type=script&lang=ts"
export * from "./CategoryStep.vue?vue&type=script&lang=ts"
import style0 from "./CategoryStep.vue?vue&type=style&index=0&id=5132f3d9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132f3d9",
  null
  
)

export default component.exports